export class ComboMetaAtendimento {
    id: number;
    descricao: string;
}